/** Returns `'mobile'` when the user agent matches a mobile/tablet pattern, otherwise `'desktop'`. */
export const getDeviceType = (): 'mobile' | 'desktop' => {
	if (typeof navigator === 'undefined') return 'desktop'
	return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
}
